<template>
    <Overlay :show="runtimeState.isLoading">
        <LegacySimilarReplyRequestSelection
            :requests="candidates.candidates"
            :selected-request-ids="candidates.selectedRequestIds"
            :error="candidates.error"
            @update:selected-request-ids="updateSelection"
            @retry="retry"
        />

        <div v-if="candidates.candidates.length > 0 && !candidates.error" class="text-center">
            <BButton class="mt-1" variant="primary" size="sm" @click="complete">
                {{ doneLabel }}
            </BButton>
        </div>
    </Overlay>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Overlay from '@core/components/common/Overlay.vue'
import LegacySimilarReplyRequestSelection from '@/views/request/received/components/send-reply/SimilarReplyRequestSelection.vue'

export default {
    name: 'SimilarReplyRequestsStep',
    components: {
        BButton,
        LegacySimilarReplyRequestSelection,
        Overlay,
    },
    props: {
        context: { type: Object, required: true },
        settings: { type: Object, required: true },
        runtimeState: { type: Object, required: true },
    },
    computed: {
        candidates() {
            return this.context.bulkReplyCandidates
        },
        doneLabel() {
            return this.$t('Component(Button):done-goto-next-step')
        },
    },
    methods: {
        updateSelection(requestIds) {
            this.$emit('action', {
                type: 'similar-reply-requests.select',
                payload: { requestIds },
            })
        },
        retry() {
            this.$emit('action', { type: 'similar-reply-requests.retry' })
        },
        complete() {
            this.$emit('completed', { isValid: true, errors: [] })
        },
    },
}
</script>
